import * as React from "react";
import styled from "styled-components";

import { createEntitiesConsumer } from "../../lib/entities";
import { Project, Company, Image } from "../entities";
import { colors, media, truncateLines } from "../../common/utils/style";
import Img from "../../common/components/Image";

interface Props {
  company: Pick<Company, "font_color_code">;
  project: Pick<Project, "project_path" | "title" | "looking_for" | "image">;
  className?: string;
}

const ImageEntitiesConsumer = createEntitiesConsumer<{ image: Image }>({ image: "images" });

class ProjectCardSimple extends React.PureComponent<Props> {
  public render() {
    const { company, project, className } = this.props;
    return (
      <Base className={className} href={project.project_path}>
        <CoverImageWrapper>
          <ImageEntitiesConsumer query={{ image: project.image }}>
            {({ image }) => image && <CoverImage image={image} size="300x200#" alt={project.title} background />}
          </ImageEntitiesConsumer>
        </CoverImageWrapper>
        <Detail>
          <LookingFor color={company.font_color_code}>{project.looking_for}</LookingFor>
          <Title>{project.title}</Title>
        </Detail>
      </Base>
    );
  }
}

const Base = styled.a`
  display: block;
  color: inherit;
  &:hover {
    text-decoration: none;
  }
`;

const CoverImageWrapper = styled.div`
  width: 100%;
  height: 140px;
  border-radius: 5px;
  background-color: ${colors.lightergray2};
  overflow: hidden;
  @media ${media.greaterThan(500)} {
    height: 200px;
  }
`;

const CoverImage = styled(Img)`
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  transition: 0.6s ease-out;

  ${Base}:hover & {
    transform: scale(1.15);
  }
`;

const Detail = styled.div`
  padding: 12px 0;
  @media ${media.large} {
    padding: 14px 0;
  }
`;

const LookingFor = styled.div`
  font-weight: 600;
  font-size: 11px;
  line-height: 1;
  color: ${(props: { color: string }) => props.color};
  margin-bottom: 6px;
  @media ${media.large} {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 13px;
  ${truncateLines(3, 13)};
  color: ${colors.gray4};
  transition: color 0.2s ease-in-out;

  @media ${media.large} {
    font-size: 14px;
    ${truncateLines(2, 14)};
  }

  ${Base}:hover & {
    color: #21bddb; /* blue400 */
  }
`;

export default ProjectCardSimple;



// WEBPACK FOOTER //
// ./frontend/src/projects/components/ProjectCardSimple.tsx